import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import NavigationItemRecord from '../../../../../records/NavigationItemRecord';
import getDisplayType from '../get-display-type';
import getBevEvent from './get-bev-name';
import isForeseeLink from '../../../isForeseeLink';
import getSectionsAsMap from './get-sections-as-map';

function parseFooterData(section) {
  if (section && Array.isArray(section.links)) {
    return section.links.map(function (footerLink) {
      var displayType = getDisplayType(footerLink);
      return new NavigationItemRecord({
        linkId: footerLink.navigationId,
        linkName: footerLink.label,
        navigationUrl: footerLink.url,
        samlNavigation: displayType === 'saml',
        externalNavigation: displayType === 'browser' || displayType === 'modal',
        bevEventId: getBevEvent(footerLink),
        opensDialog: isForeseeLink(footerLink),
        displayType: displayType,
        anchorTagAttributes: footerLink.dataAttributes || {}
      });
    });
  } else {
    return [];
  }
}

export default function getFooterNavItems(footerSection) {
  if (footerSection && footerSection.sections instanceof Array) {
    var sectionsMap = getSectionsAsMap(footerSection.sections);
    return {
      leftLinks: parseFooterData(sectionsMap['S_LEFT_FOOTER']),
      rightLinks: parseFooterData(sectionsMap['S_RIGHT_FOOTER'])
    };
  } else {
    return {
      leftLinks: [],
      rightLinks: []
    };
  }
}